import { useEffect, useState } from "react";

const useWebToApp = () => {
  const [state, setState] = useState<DynamicJsonTypes>({});

  useEffect(() => {
    const setContext = (payload: any) => {
      setState(JSON.parse(payload));
    };

    // webInterface
    window.SKPAdInquiryWeb = {
      setInquiryContext: (e) => {
        setContext(e);
      },
    };

    // aos || ios appInterface
    const aosInterface = window.SKPAdInquiryNative;
    const iosInterface = window.webkit?.messageHandlers?.SKPAdInquiryNative;
    if (aosInterface) {
      aosInterface.requestInquiryContext();
    } else if (iosInterface) {
      iosInterface.postMessage({ command: "requestInquiryContext", params: {} });
    }
  }, []);

  return { state };
};

export default useWebToApp;
